
import Vue from 'vue';
import LinkHandler from '@core/components/helpers/LinkHandler.vue';
import SocialLinks from '@root/common/components/base/SocialLinks.vue';
import { Footer } from '@root/modules/navigation/types/navigation';
import rootConfig from '@root/config/root.config';

interface Props {
  navigation: Footer;
}

interface Data {
  rootConfig: Record<string, unknown>;
}

interface Computed {
  privacyPolicyUrl: string;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  components: {
    LinkHandler,
    SocialLinks,
  },
  props: {
    navigation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      rootConfig,
    };
  },
  computed: {
    privacyPolicyUrl() {
      const { id } = this.$channelConfig('settings');

      if (id === 'ru') {
        return rootConfig.privacy_policy_url_ru;
      }

      if (id === 'en') {
        return rootConfig.privacy_policy_url_en;
      }

      return rootConfig.privacy_policy_url;
    },
  },
});
